export default __webpack_public_path__ + "f10585df6679e439d216198c08fb38e6.png";